var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$route.name === 'manual' ? 'QuestionIndex' : 'QuestionForm',{tag:"component",attrs:{"product":_vm.product}})}
var staticRenderFns = []

export { render, staticRenderFns }